module.exports = __webpack_public_path__ + "img/英国站.2f847fb6.png";